<template>
  <div v-if="$page" class="content__header">
    <div class="content padding__page">
      <h1 class="h1 mb-40">{{ $page.title }}</h1>
      <div v-for="(article, index) in $page.content" :key="index">
        <h2>{{ article.title }}</h2>
        <p class="paragraph mt-16 mb-40">{{ article.content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import PageMetaMixin from '@/mixins/PageMetaMixin.js'

export default {
  name: 'Disclaimer',
  beetPage: 'disclaimer',
  mixins: [PageMetaMixin],
}
</script>
